// nummer erbij optellen waarbij eerst gecheckt wordt of het nummer wel valide is
export function addPriceToTotal(oCosts, nSubTotal)
{
  if ( typeof nSubTotal === 'undefined' || typeof oCosts === 'undefined' || nSubTotal === false ) return;
  let nCosts = parseFloat(oCosts);

  nSubTotal = Math.round((nSubTotal + nCosts) * 1e12) / 1e12; // http://stackoverflow.com/questions/10473994/javascript-adding-decimal-numbers-issue

  return nSubTotal;
}

/**
 * "0.00" => 0
 * "23.30" => 2330
 * @param sInputPrice
 */
export function stringToCents(sInputPrice)
{
  // console.log('stringToCents voor ', sInputPrice);
  if ( typeof sInputPrice === 'number' ) sInputPrice = sInputPrice.toString() + '';
  if ( typeof sInputPrice !== 'string' ) return false;

  let sPrice = sInputPrice.replace('.', ',');
  let aParts = sPrice.split(',');
  if ( aParts.length > 1 )
  {
    // check laatste part of dat niet bijv 5 is (moet 50 zijn voor 50 cent)
    if ( aParts[aParts.length - 1].length === 1 ) aParts[aParts.length - 1] = aParts[aParts.length - 1] + '0';
  }
  else
  {
    aParts[1] = '00';
  }
  sPrice = aParts.join('');

  let iResponse = sPrice.match(/[0-9]/g).join('');
  let i = 0;

  while ( iResponse.substr(0, 1) === '0' && i < 10 )
  {
    iResponse = iResponse.substr(1);
    ++i;
  }

  if ( iResponse === '' ) iResponse = 0;
  iResponse = parseInt(iResponse);

  if ( sInputPrice.substring(0, 1) === "-" )
  {
    iResponse = iResponse * -1;
  }

  // console.log('stringToCents na ', iResponse);
  return iResponse;
}

export function centsToFriendly(iInputCents)
{
  iInputCents = parseInt(iInputCents);
  const sInputCents = iInputCents + '';
  let sCents = '00';
  let sEuros = '0';

  if ( sInputCents.length === 1 )
  {
    sCents = '0' + sInputCents;
  }
  else if ( sInputCents.length === 2 )
  {
    sCents = sInputCents;
  }
  else
  {
    sEuros = sInputCents.substr(0, sInputCents.length - 2);
    sCents = sInputCents.substr(-2);
  }

  return {
    sEuros: sEuros,
    sCents: sCents
  };
};

export function centsToString(iInputCents, sDelimiter = ",")
{
  iInputCents = parseInt(iInputCents);
  const sInputCents = iInputCents + '';
  let sCents = '00';
  let sEuros = '0';

  if ( sInputCents.length === 1 )
  {
    sCents = '0' + sInputCents;
  }
  else if ( sInputCents.length === 2 )
  {
    sCents = sInputCents;
  }
  else
  {
    sEuros = sInputCents.substr(0, sInputCents.length - 2);
    sCents = sInputCents.substr(-2);
  }

  return sEuros + sDelimiter + sCents;
}

export function numberAmountToString(nInputPrice)
{
  let sPrice = nInputPrice;
  if ( typeof sPrice.toLowerCase === 'function' && sPrice.toLowerCase() === 'incl' ) return nInputPrice;

  sPrice = sPrice + '';
  let aPriceParts = sPrice.split('.');

  // 1.2 > 1.20
  if ( aPriceParts.length > 1 && sPrice.split('.')[1].length > 2 ) sPrice = sPrice.split('.')[0] + '.' + sPrice.split('.')[1].substr(0, 2); // voor het geval dit mocht voorkomen: 12,329239239
  if ( aPriceParts.length > 1 && sPrice.split('.')[1].length === 1 )
  {
    sPrice = sPrice + '0';
  }

  // 12 > 12.00
  if ( aPriceParts.length === 1 || aPriceParts.length === 0 ) sPrice = sPrice + ',00';

  sPrice = sPrice.replace(/\./g, ',');

  return sPrice;
}